import { Component, OnInit } from '@angular/core';
import { BoletoService } from './boleto.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Dados, ErrorAPI } from './boleto';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';
import { EnvService } from "../env/env.service";

declare var bootstrap: any;
declare const Mask: any;
declare const grecaptcha: any;

@Component({
  templateUrl: './boleto.component.html',
})
export class BoletoComponent implements OnInit {
  private _cpfcnpj_beneficiario: string = "";
  public captchaResolved: boolean = false;
  private captchaToken: string = "";
  private _cpfcnpj_pagador: string = "";
  private _nosso_numero: number = 0;
  private _pesquisou: boolean = false;
  private _historico: boolean = false;
  private _dados: Dados;
  public _KCaptchaEy: string = "";

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private boletoService: BoletoService, private env: EnvService) {
    console.log("Versão: 12.059.008");
    this._dados = new Dados;
    this._KCaptchaEy = env.SiteKeyGoogle;
  }

  ngOnInit(): void {
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map((popoverTriggerEl: any) => new bootstrap.Popover(popoverTriggerEl));
  }

  set beneficiario(value: string) {
    this._cpfcnpj_beneficiario = value;
  }
  get beneficiario() {
    return this._cpfcnpj_beneficiario;
  }
  set pagador(value: string) {
    this._cpfcnpj_pagador = value;
  }
  get pagador() {
    return this._cpfcnpj_pagador;
  }
  set nossonumero(value: number) {
    this._nosso_numero = Number(value);
  }
  get nossonumero() {
    return this._nosso_numero;
  }
  get historicoBoleto() {

    return this._dados;
  }
  funcaoCPFCNPJ(dado: number) {
    Mask(dado);
  }
   formatarCnpjAlfa(event: Event, campo: string): void {
    const input = event.target as HTMLInputElement;

    let limpo = input.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (limpo.length > 14) limpo = limpo.substring(0, 14);

    if (limpo.length > 12) {
      limpo = limpo.substring(0, 12) + limpo.substring(12).replace(/[^0-9]/g, '');
    }

    let formatado = '';
    for (let i = 0; i < limpo.length; i++) {
      if (i === 2) formatado += '.';
      if (i === 5) formatado += '.';
      if (i === 8) formatado += '/';
      if (i === 12) formatado += '-';
      formatado += limpo[i];
    }

    input.value = formatado;
    (this as any)[campo] = formatado;
  }
  async pesquisar() {
    if ((document.getElementById("Radio1beneficiario") as HTMLInputElement).checked) {
      this.beneficiario = (document.getElementById("beneficiariocpf") as HTMLInputElement).value;
    } else {
      this.beneficiario = (document.getElementById("beneficiariocnpj") as HTMLInputElement).value;
    }
    if ((document.getElementById("Radio1pagador") as HTMLInputElement).checked) {
      this.pagador = (document.getElementById("pagadorcpf") as HTMLInputElement).value;
    } else {
      this.pagador = (document.getElementById("pagadorcnpj") as HTMLInputElement).value;
    }
    this._pesquisou = true;
    if (this.invalidado()) {
    } else {
      this.boletoService.ConsultarHistorico(this.captchaToken, this.beneficiario, this.pagador, this.nossonumero).pipe(
      ).subscribe(
        ret => {
          this._dados = ret[0].titulo[0];

          if (this._dados.siglaOperacao == "A") {
            this._dados.dtProcessamento = new Date(this._dados.dtEntrada);
            this._historico = true;
          } else {
            Swal.fire("Informativo", "Boleto encontra-se baixado ou liquidado.", "error").then((x) => { this.refreshCaptcha() });
          }
        }
        ,
        err => {
          let erro: HttpErrorResponse;
          let erroAPI: ErrorAPI;
          erro = err;
          if (erro.status != 200) {
            Swal.fire("Erro", "Boleto não encontrado.", "error").then((x) => { this.refreshCaptcha() });
          } else {
            erroAPI = erro.error;
            if (erroAPI.codigo == 0) {
              Swal.fire("Erro", erroAPI.mensagem, "error").then((x) => { this.refreshCaptcha() });
            } else {
              Swal.fire("Informativo", erroAPI.mensagem, "error").then((x) => { this.refreshCaptcha() });
            }
          }
          this._historico = false;
        }
      )
      this.refreshCaptcha();
    }
  }
  pesquisar2(comando: number) {
    if (this._pesquisou) {
      switch (comando) {
        case 1:
        case 2:
          var aux = this.beneficiario.trim().replace(".", "").replace("-", "").replace(".", "").replace("/", "");
          var aux2 = (document.getElementById("Radio1beneficiario") as HTMLInputElement).checked;
          if ((aux2 && comando == 1 && aux.length != 11) || (!aux2 && comando == 2 && aux.length != 14)) {
            return true;
          }
          break;
        case 3:
        case 4:
          var aux = this.pagador.trim().replace(".", "").replace("-", "").replace(".", "").replace("/", "");
          var aux2 = (document.getElementById("Radio1pagador") as HTMLInputElement).checked;
          if ((aux2 && comando == 3 && aux.length != 11) || (!aux2 && comando == 4 && aux.length != 14)) {
            return true;
          }
          break;
        case 5:
          if (this.nossonumero <= 0) {
            return true;
          }
      }
      return false;;
    } else {
      return false;
    }
  }
  invalidado() {
    if (this.pesquisar2(1) || this.pesquisar2(2) || this.pesquisar2(3) || this.pesquisar2(4) || this.pesquisar2(5)) {
      return true;
    }
    else {
      return false;
    }
  }
  limpar() {
    this._cpfcnpj_beneficiario = "";
    this._cpfcnpj_pagador = "";
    this._nosso_numero = 0;
    (document.getElementById("beneficiariocpf") as HTMLInputElement).value = this._cpfcnpj_beneficiario;
    (document.getElementById("beneficiariocnpj") as HTMLInputElement).value = this._cpfcnpj_beneficiario;
    (document.getElementById("pagadorcpf") as HTMLInputElement).value = this._cpfcnpj_pagador;
    (document.getElementById("pagadorcnpj") as HTMLInputElement).value = this._cpfcnpj_pagador;
    (document.getElementById("Radio1beneficiario") as HTMLInputElement).checked = true;
    (document.getElementById("Radio1pagador") as HTMLInputElement).checked = true;
    (document.getElementById("Radio2beneficiario") as HTMLInputElement).checked = false;
    (document.getElementById("Radio2pagador") as HTMLInputElement).checked = false;
    Mask(1);
    Mask(2);
    this._pesquisou = false;
    this._historico = false;
  }
  historico() {
    return this._historico;
  }
  async EmitirBoleto() {
    if ((document.getElementById("Radio1beneficiario") as HTMLInputElement).checked) {
      this.beneficiario = (document.getElementById("beneficiariocpf") as HTMLInputElement).value;
    } else {
      this.beneficiario = (document.getElementById("beneficiariocnpj") as HTMLInputElement).value;
    }
    if ((document.getElementById("Radio1pagador") as HTMLInputElement).checked) {
      this.pagador = (document.getElementById("pagadorcpf") as HTMLInputElement).value;
    } else {
      this.pagador = (document.getElementById("pagadorcnpj") as HTMLInputElement).value;
    }
    this._pesquisou = true;
    if (this.invalidado()) {
    } else {
      this.boletoService.ConsultarBoletoEmUmPasso(this.captchaToken, this.beneficiario, this.pagador, this.nossonumero).pipe(
      ).subscribe(
        ret => {
          this.boletoService.valorhtml = ret[0].linkBoleto;
          this.router.navigate(['boleto/PDF']);
        },
        err => {
          let erro: HttpErrorResponse;
          let erroAPI: ErrorAPI;
          erro = err;
          let result = JSON.parse(erro.error.mensagem);
          if (erro.status != 200) {
            Swal.fire("Erro", result.codigo == 21 ? "Boleto enviado para protesto, não é possível gerar 2° via." : "Boleto não encontrado.", "error").then((x) => { this.refreshCaptcha() });
          } else {
            erroAPI = erro.error;
            if (erroAPI.codigo == 0) {
              Swal.fire("Erro", erroAPI.mensagem, "error").then((x) => { this.refreshCaptcha() });
            } else {
              Swal.fire("Informativo", erroAPI.mensagem, "error").then((x) => { this.refreshCaptcha() });
            }
          }
        }
      )
    }
  }

  refreshCaptcha() {
    grecaptcha.reset();
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved = (captchaResponse && captchaResponse.length > 0) ? true : false;
    if (this.captchaResolved) {
      this.captchaToken = captchaResponse;
    }
  }

  async refresh() {
    await new Promise(r => setTimeout(r, 1500));
    window.location.reload();
  }
}
